import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { CommentInterface, setEditId, setEditError, selectCommentById } from "../../../store/mods_factory/commentsSlice";
import { updateComment, fetchComment } from "../../../actions/mods_factory/commentsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.modsFactory.comments.editId);
  const error   = useAppSelector(state => state.modsFactory.comments.editError);
  const comment = useAppSelector(state => selectCommentById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchComment(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: CommentInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: CommentInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateComment({ id, data: formData }));

    if (updateComment.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-comment'>
        <h6 className="v-content-label">Edit Comment</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={comment} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
